export default{
  props: ["data", "companyId"],
  methods: {
    viewDetail(data){
      if(this.companyId){
        this.setApi((api, key)=>{
          if(api){
            let params = {
              Id: data.id,
              CompanyId: this.companyId
            }

            if(key == 'equityFreezeCheckDetail'){
              if(this.data.relatedInfo && this.data.relatedInfo.keyNo){
                params.KeyNo = keyNo;
              }
            }

            api(params).then(res=>{
              this.resetData(res.data, (data) => {
                res.data = data;
              });
    
              if(key != null){
                localStorage.setItem('risk_detail_data', JSON.stringify(res.data));
                this.$router.push({
                  name: "ScanSubDetail",
                  query: { key },
                });
              }
            })
          }
        })
      }
    },
    setApi(callback){
      callback && callback();
    },
    resetData(data, callback){
      callback && callback(data);
    }
  }
}